// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2zdkB","header":"MergedInvoice_header__2QliR"};